/* HOAD: Avaliações (22/09, redesenhado 22/09) — busca via proxy
   /api/geral/judgeme-reviews (esconde o Private Token), renderiza em
   carrossel (arrasto nativo, mesmo padrão de hoad-product-showcase.js),
   foto sempre no mesmo formato, texto longo trunca com "Ver mais" que abre
   o comentário completo num modal. Shape exato da resposta do Judge.me
   ajustável só nos getters abaixo caso a API real venha diferente.

   23/09 (bug real achado pelo André no editor de tema): a loja
   (hoad.com.br) e o backend (app.hoad.com.br) são domínios DIFERENTES —
   um fetch relativo ('/api/geral/...') nunca alcança o Vercel, sempre cai
   no roteamento da própria Shopify (404). Precisa da URL absoluta. */
(function () {
  var HOAD_API_BASE = 'https://app.hoad.com.br';

  function svgStar(filled) {
    return (
      '<svg class="hoad-reviews__star' + (filled ? ' is-filled' : '') + '" viewBox="0 0 20 20" aria-hidden="true">' +
      '<path d="M10 1l2.6 5.9 6.4.6-4.8 4.3 1.4 6.2L10 14.9 4.4 18l1.4-6.2L1 7.5l6.4-.6z"/></svg>'
    );
  }

  function svgCheck() {
    return (
      '<svg class="hoad-reviews__verified" viewBox="0 0 20 20" aria-hidden="true">' +
      '<path d="M10 1a9 9 0 100 18 9 9 0 000-18zm-1.2 13L4.6 9.8l1.4-1.4 2.8 2.8 5.2-5.2 1.4 1.4z"/></svg>'
    );
  }

  function starsHtml(rating, size) {
    var n = Math.round(Number(rating) || 0);
    var out = '<div class="hoad-reviews__stars"' + (size ? ' style="--hoad-star-size:' + size + '"' : '') + '>';
    for (var i = 1; i <= 5; i++) out += svgStar(i <= n);
    return out + '</div>';
  }

  function reviewerName(name) {
    var parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return 'Cliente HOAD';
    return parts.slice(0, 2).join(' ');
  }

  function reviewPhoto(review) {
    var pics = review.pictures || review.photos || [];
    if (!pics.length) return '';
    var p = pics[0];
    // 23/09: "small"/"compact" do Judge.me são 160px de largura — esticado
    // no card (bem maior que isso) fica borrado. "original"/"huge" tem
    // 1024px, o object-fit:cover cuida do enquadramento sem perder nitidez.
    return typeof p === 'string' ? p : (p.urls && (p.urls.original || p.urls.huge || p.urls.small)) || p.url || '';
  }

  function variantText(review) {
    return review.variant_title || review.variant || (review.order_item && review.order_item.variant_title) || '';
  }

  function cardHtml(review, index) {
    var photo = reviewPhoto(review);
    var body = review.body || review.content || '';
    var variant = variantText(review);
    return (
      '<article class="hoad-reviews__card" data-hoad-review-card data-index="' + index + '">' +
      '<div class="hoad-reviews__card-media">' + (photo ? '<img src="' + photo + '" alt="" loading="lazy">' : '') + '</div>' +
      '<div class="hoad-reviews__card-body">' +
      starsHtml(review.rating) +
      '<div class="hoad-reviews__reviewer">' + reviewerName((review.reviewer && review.reviewer.name) || review.name) + (review.verified ? svgCheck() : '') + '</div>' +
      (review.title ? '<p class="hoad-reviews__title">' + review.title + '</p>' : '') +
      '<p class="hoad-reviews__body" data-hoad-review-body>' + body + '</p>' +
      '<button type="button" class="hoad-reviews__more" data-hoad-review-more hidden>Ver mais</button>' +
      (variant ? '<div class="hoad-reviews__variant">Tipo de artigo: ' + variant + '</div>' : '') +
      '</div></article>'
    );
  }

  function initCarousel(section, reviews) {
    var viewport = section.querySelector('[data-hoad-reviews-viewport]');
    var track = section.querySelector('[data-hoad-reviews-track]');
    var dotsWrap = section.querySelector('[data-hoad-reviews-dots]');
    if (!viewport || !track) return;

    track.innerHTML = reviews.map(cardHtml).join('');
    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-hoad-review-card]'));

    // "Ver mais" só aparece se o texto realmente estourar as 3 linhas do
    // line-clamp — comparar scrollHeight vs clientHeight depois do layout.
    cards.forEach(function (card) {
      var body = card.querySelector('[data-hoad-review-body]');
      var moreBtn = card.querySelector('[data-hoad-review-more]');
      if (!body || !moreBtn) return;
      if (body.scrollHeight - body.clientHeight > 2) {
        moreBtn.hidden = false;
        moreBtn.addEventListener('click', function () {
          var i = Number(card.dataset.index);
          openModal(section, reviews[i]);
        });
      }
    });

    if (dotsWrap) {
      dotsWrap.innerHTML = reviews.map(function (_, i) {
        return '<button type="button" class="hoad-reviews__dot" data-dot-index="' + i + '" aria-label="Ir pra avaliação ' + (i + 1) + '"></button>';
      }).join('');
      var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-dot-index]'));
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var card = cards[i];
          if (card) viewport.scrollTo({ left: card.offsetLeft - 24, behavior: 'smooth' });
        });
      });

      function updateDots() {
        var viewportLeft = viewport.getBoundingClientRect().left;
        var closest = 0;
        var closestDist = Infinity;
        cards.forEach(function (card, i) {
          var dist = Math.abs(card.getBoundingClientRect().left - viewportLeft);
          if (dist < closestDist) { closestDist = dist; closest = i; }
        });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === closest); });
      }
      var rafId = null;
      viewport.addEventListener('scroll', function () {
        if (rafId) return;
        rafId = requestAnimationFrame(function () { updateDots(); rafId = null; });
      }, { passive: true });
      updateDots();
    }

    // Arrasto pelo mouse (touch já rola nativo via overflow-x) — mesmo
    // padrão de hoad-product-showcase.js.
    var isDragging = false, dragStartX = 0, dragStartScroll = 0, dragMoved = false;
    viewport.addEventListener('mousedown', function (e) {
      isDragging = true; dragMoved = false;
      dragStartX = e.clientX; dragStartScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
    });
    window.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      var delta = e.clientX - dragStartX;
      if (Math.abs(delta) > 4) dragMoved = true;
      viewport.scrollLeft = dragStartScroll - delta;
    });
    window.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      viewport.classList.remove('is-dragging');
    });
    viewport.addEventListener('click', function (e) {
      if (dragMoved) { e.preventDefault(); dragMoved = false; }
    });
  }

  function openModal(section, review) {
    var modal = section.querySelector('[data-hoad-reviews-modal]');
    if (!modal) return;
    var photo = reviewPhoto(review);
    modal.querySelector('[data-hoad-modal-media]').innerHTML = photo ? '<img src="' + photo + '" alt="">' : '';
    modal.querySelector('[data-hoad-modal-stars]').outerHTML = starsHtml(review.rating, '16px').replace('<div', '<div data-hoad-modal-stars');
    modal.querySelector('[data-hoad-modal-reviewer]').textContent = reviewerName((review.reviewer && review.reviewer.name) || review.name);
    modal.querySelector('[data-hoad-modal-title]').textContent = review.title || '';
    modal.querySelector('[data-hoad-modal-body]').textContent = review.body || review.content || '';
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal(section) {
    var modal = section.querySelector('[data-hoad-reviews-modal]');
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  function init(section) {
    var productId = section.dataset.productId;
    if (!productId) return;

    var modal = section.querySelector('[data-hoad-reviews-modal]');
    if (modal) {
      modal.querySelector('[data-hoad-modal-close]').addEventListener('click', function () { closeModal(section); });
      modal.querySelector('[data-hoad-modal-backdrop]').addEventListener('click', function () { closeModal(section); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(section); });
    }

    var track = section.querySelector('[data-hoad-reviews-track]');

    // Família (cores do mesmo produto) somada; sem família, só o produto.
    window.HoadReviewsFamilia.buscar(section.dataset.productIds || productId, 40)
      .then(function (reviews) {
        var data = {};
        if (!reviews.length) {
          track.innerHTML = '<div class="hoad-reviews__empty">Ainda não tem avaliação pra esse produto.</div>';
          return;
        }
        var summary = section.querySelector('[data-hoad-reviews-summary]');
        if (summary) {
          var avg = data.average_rating || (reviews.reduce(function (a, r) { return a + (Number(r.rating) || 0); }, 0) / reviews.length);
          summary.innerHTML = starsHtml(avg) + '<span>' + reviews.length + ' avaliaç' + (reviews.length === 1 ? 'ão' : 'ões') + '</span>';
        }
        initCarousel(section, reviews);
      })
      .catch(function (err) {
        console.error('[hoad-reviews]', err);
        track.innerHTML = '<div class="hoad-reviews__error">Não deu pra carregar as avaliações agora.</div>';
      });
  }

  function boot() {
    document.querySelectorAll('[data-hoad-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-hoad-reviews]');
    if (section) init(section);
  });
})();
